(() => {
  if (window.McPettyPolicy?.initialize) {
    window.McPettyPolicy.initialize();
    return;
  }
  const isHeading = (node) => {
    if (node.nodeType !== Node.ELEMENT_NODE) return false;
    if (/^H[1-6]$/.test(node.tagName)) return true;
    if (node.tagName !== 'P') return false;
    const children = [...node.childNodes].filter((child) => child.nodeType !== Node.TEXT_NODE || child.textContent.trim());
    return children.length === 1 && children[0].nodeType === Node.ELEMENT_NODE && /^(STRONG|B)$/.test(children[0].tagName);
  };

  const formatPolicy = (root) => {
    const source = root.querySelector('[data-mcpetty-policy-content]');
    if (!source || source.dataset.formatted === 'true') return;
    source.dataset.formatted = 'true';
    const expandWrapper = (node) => {
      if (node.nodeType === Node.ELEMENT_NODE && /^(DIV|SECTION|ARTICLE)$/.test(node.tagName) && node.querySelector('h1,h2,h3,h4,h5,h6')) return [...node.childNodes].flatMap(expandWrapper);
      return [node];
    };
    const nodes = [...source.childNodes].flatMap(expandWrapper);
    const fragment = document.createDocumentFragment();
    let currentContent;
    let hasRows = false;
    let hasIntro = false;

    const createRow = (heading) => {
      const row = document.createElement('section');
      row.className = 'mcpetty-policy-row';
      if (heading) {
        heading.classList.add('mcpetty-policy-row__title');
        if (heading.tagName === 'P') {
          heading.setAttribute('role', 'heading');
          heading.setAttribute('aria-level', '2');
        }
        row.append(heading);
      } else {
        const title = document.createElement('span');
        title.className = 'mcpetty-policy-row__title';
        title.setAttribute('aria-hidden', 'true');
        row.append(title);
      }
      currentContent = document.createElement('div');
      currentContent.className = 'mcpetty-policy-row__content';
      row.append(currentContent);
      fragment.append(row);
      hasRows = true;
    };

    for (const node of nodes) {
      if (isHeading(node)) {
        createRow(node);
      } else if (!hasRows && !hasIntro && node.nodeType === Node.ELEMENT_NODE && node.tagName === 'P' && node.textContent.trim()) {
        node.classList.add('mcpetty-policy-intro');
        fragment.append(node);
        hasIntro = true;
      } else if (node.nodeType === Node.TEXT_NODE && !node.textContent.trim()) {
        (currentContent || fragment).append(node);
      } else {
        if (!currentContent) createRow();
        currentContent.append(node);
      }
    }
    source.replaceChildren(fragment);
  };

  const initialize = (container = document) => {
    if (container.matches?.('[data-mcpetty-policy]')) formatPolicy(container);
    container.querySelectorAll('[data-mcpetty-policy]').forEach(formatPolicy);
  };
  window.McPettyPolicy = { initialize };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
